import { Divider, Link, Spacer, Typography } from "@fullscript/aviary-web";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";

import { QrCode } from "../../components/QrCode/QrCode";

import * as styles from "./EnableWithAuthenticator.styles";

interface Props {
  qrCodeUrl: string;
  manualSetupCode: string;
  children: ReactNode;
  isModal?: boolean;
}

const EnableWithAuthenticator = ({
  qrCodeUrl,
  manualSetupCode,
  children,

  isModal,
}: Props) => {
  const { t } = useTranslation();

  const renderTitle = () => {
    if (isModal) {
      return (
        <>
          <Typography variant="h4" intention="neutral" colorIntensity="bold">
            {t(l.mfa.enableWithAuthenticator.title)}
          </Typography>
          <Typography>
            {t(l.mfa.enableWithAuthenticator.subtitle)}{" "}
            <Link
              href={sharedRoutes.external.enablingMultiFactorAuthenticationAuthenticatorAppOption}
            >
              {t(l.sharedCommon.learnMore)}
            </Link>
          </Typography>
          <Spacer />
        </>
      );
    }

    return (
      <div css={styles.header}>
        <Typography variant="h1" intention="neutral" colorIntensity="bold">
          {t(l.mfa.enableWithAuthenticator.title)}
        </Typography>
      </div>
    );
  };

  return (
    <>
      {renderTitle()}
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.step1)}
      </Typography>
      <>
        <Typography>{t(l.mfa.enableWithAuthenticator.scanTheQrCode)}</Typography>
        <Spacer size="xsmall" />
        <QrCode url={qrCodeUrl} manualSetupCode={manualSetupCode} />
      </>
      <Divider customCss={styles.separator} />
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.step2)}
      </Typography>
      <Typography>{t(l.mfa.enterCodeFromAuthenticator)}</Typography>
      {children}
      <Spacer />
    </>
  );
};

export { EnableWithAuthenticator };
